import React from 'react';
import '../svg.css';


const Other = props => {

    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36"
            height="36px"
            width="36px"
            className='svg'
        >
            <g id="messages_other" data-name="messages/other"><g id="Logo"><rect id="frame" className="other-1" width="36" height="36" rx="10" /></g><rect id="bound" className="other-2" x="6" y="6" width="24" height="24" /><circle id="Oval-67" className="other-3" cx="11" cy="18" r="2" /><circle id="Oval-67-Copy" className="other-3" cx="18" cy="18" r="2" /><circle id="Oval-67-Copy-2" className="other-3" cx="25" cy="18" r="2" /></g></svg>
    )
};

export default Other;
